import React, { forwardRef } from 'react';

import styled from '@mint-lib/styled';
import PopoverM, { PopoverProps } from '@mui/material/Popover';

/**
 * @deprecated Use the new Popover component from @mint-lib/tw-components instead.
 */
const Popover = forwardRef(
  (props: PopoverProps, ref: React.ForwardedRef<HTMLDivElement>) => {
    return <StyledPopover {...props} ref={ref} />;
  },
);

export default Popover;

const StyledPopover = styled(PopoverM)({
  marginTop: '4px',
});
